<template>
  <div>
    <!--删除购物车商品-->
    <!-- 
      v-model="noLoginModel"

     -->
    <Modal class="no-login-box" :value.sync="dialogVisible" :closable="false" :scrollable="true" :footer-hide="true" :styles="{ top: '300px' }"
      width="300">
      <p class="item-close" @click="close()">
        <img src="static/img/popup/close.png" alt="" />
      </p>
      <p class="item-img">
        <img src="static/img/popup/icon_noLogin.png" alt="" />
      </p>
      <p class="item-txt-1">温馨提示</p>
      <p class="item-txt-2">删除您选择的商品？</p>
      <div class="item-btn">
        <p class="btn-yes" @click="delCart()">确定</p>
        <p class="btn-no" @click="close()">取消</p>
      </div>
    </Modal>
    <!--删除购物车商品-->
  </div>
</template>

<script>
import { delGoodsCart } from "@/api/goods";

export default {
  name: "DeleteCart",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    delIds: {
      type: String,
      default: ""
    },
    type: {
      type: Number,
      default: 0 //0，删除指定商品，1删除无库存下架商品
    }
  },
  data() {
    return {
      noLoginModel: true
    };
  },
  methods: {
    delCart() {
      if ((this.type === 0) && (!this.delIds || this.delIds.length <= 0)) {
        this.$Message.error("参数错误");
        return;
      }
      delGoodsCart({ cart_ids: this.delIds, type: this.type })
        .then(res => {
          console.log(res);
          this.$message({
            type: "success",
            message: res.msg || "删除成功!"
          });
          if (this.type === 1) {
            this.$emit("del-success");
            this.$emit("update:dialogVisible", false);
          } else {
            this.$parent.deleteSingleCart(this.delIds);
            this.$emit("update:dialogVisible", false);

          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            type: "error",
            message: err || "删除失败"
          });
        });
    },
    close() {
      this.$emit("update:dialogVisible", false);
    }
  }
};
</script>

<style lang="less" scoped>
.no-login-box {
  text-align: center;
  .item-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: -14px;
    top: -25px;
    cursor: pointer;
  }
  .item-img {
    width: 148px;
    height: 81px;
    margin: 30px auto auto auto;
  }
  .item-txt-1 {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-top: 18px;
  }
  .item-txt-2 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    padding-top: 6px;
  }
  .item-btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 35px;
    .btn-yes {
      width: 120px;
      height: 40px;
      background: linear-gradient(270deg, #4098ff 0%, #358DD1 100%);
      box-shadow: 0px 2px 6px 0px rgba(0, 93, 195, 0.3);
      border-radius: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
    .btn-no {
      width: 120px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #f0f0f0;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.no-login-box /deep/ ivu-modal {
}
.no-login-box /deep/ .ivu-modal-content {
  position: relative;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/DeleteCart.vue